import { Grid, Typography } from "@material-ui/core";
import { useEffect, useReducer } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import CustomAlert from "../../componentes/alerts/CustomAlert";
import { DefaultAutocomplete } from "../../componentes/autocomplete/DefaultAutocomplete";
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import { IconSwitch } from "../../componentes/iconSwitch/IconSwitch";
import { DefaultDatagrid } from "../../componentes/datagrid/DefaultDatagrid";
import InputField from "../../componentes/form-fields/InputField/InputField";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import ClientControlService from "./ClientControlService";
import DefaultChip from "../../componentes/chip/DefaultChip";
/**
 * Author : Lucas
 * 30/12/2025
*/
const columns = (t) => [
    { field: "id", flex: 0.5, visible: false },
    {
        field: "idPrinter",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="ids" name="idPrinter" />;
        },
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="grey"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.idPrinter}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "namePrinter",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="printer" name="namePrinter" />;
        },
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="grey"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.namePrinter}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "status",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="status" />;
        },
        flex: 0.5,
        template: (props) => {
            return (
                <>
                    {props.status == 1 ? (
                        <IconSwitch name="active" />
                    ) : (
                        <IconSwitch name="canceled" />
                    )}
                </>
            );
        },
    },
];

export const ClientPrint = ({ idClient }) => {
    const { t } = useTranslation();
    const userId = sessionStorage.getItem("userId");

    const initialState = {
        id: 0,
        idClient: idClient,
        idPrinter: 0,
        namePrinter: "",
        rows: [],
        loggedUserId: userId,
        status: 1,
        success: false,
        error: false,
    };

    const reducer = (state, action) => {
        switch (action.type) {
            case 'update':
                return { ...state, ...action.data }
            case "clear":
                return initialState
            case 'success':
                return { ...state, success: true, error: false }
            case 'error':
                return { ...state, success: false, error: true }
            case 'close_alert':
                return { ...state, success: false, error: false }
            default:
                return new Error();
        }
    }

    const [state, dispatch] = useReducer(reducer, initialState);

    const { id, idPrinter, namePrinter, status } = state
    const { success, error, rows, ...data } = state

    const handleChange = ({ target: { name, value } }) => {
        dispatch({ type: 'update', data: { [name]: value } })
    }

    const handleSearch = () => {
        ClientControlService
            .getClientPrinter(data)
            .then((response) => {
                if (response.status === 200) {
                    console.log("response.data clientePrint", response.data);
                    dispatch({ type: 'update', data: { rows: response.data } })
                }
            })
            .catch((e) => dispatch({ type: 'update', data: { rows: [] } }));
    }

    const canSave = () => idPrinter !== "";

    const handleSaveUpdate = () => {
        if (canSave()) {
            if (id) {
                ClientControlService
                    .updateClientPrinter(data)
                    .then((response) => {
                        if (response.status === 200) {
                            dispatch({ type: 'success' })
                            handleSearch();
                        }
                    })
                    .catch((e) => dispatch({ type: 'error' }));
            }
            else {
                ClientControlService
                    .createClientPrinter(data)
                    .then((response) => {
                        if (response.status === 200) {
                            dispatch({ type: 'update', data: { success: true, error: false, id: response.data.id } })
                            handleSearch();
                        }
                    })
                    .catch((e) => dispatch({ type: 'error' }));
            }
        } else {
            dispatch({ type: 'error' })
        }
    }

    const handleCellClick = (data) => {
        dispatch({
            type: 'update', data: {
                id: data.id,
                idPrinter: data.idPrinter,
                status: data.status,
            }
        })
    }

    useEffect(() => {
        handleSearch();
    }, [])

    return (
        <DefaultScreenAccordion
            title={"printer"}
            isRegister
            fields={
                <GridItemContainer>
                    <CustomAlert
                        success={success}
                        error={error}
                        handleCloseAlert={() => dispatch({ type: 'close_alert' })}
                    />
                    <GridInputRow>
                        <Grid item xs={6} md={3}>
                            <DefaultAutocomplete
                                name="idPrinter"
                                onChange={handleChange}
                                value={idPrinter}
                                label={t("printer")}
                                defaultSize
                                useApi
                                endpoint='GetPrinter'
                                error={error && idPrinter === 0}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <DefaultAutocomplete
                                name={"status"}
                                onChange={handleChange}
                                value={status}
                                label={t("status")}
                                defaultSize
                                error={error && status === 2}
                                items={[
                                    { id: 0, name: t("canceled"), status: 1 },
                                    { id: 1, name: t("active"), status: 1 },
                                    { id: 2, name: t("all"), status: 1 },
                                ]}
                            />
                        </Grid>
                    </GridInputRow>
                    <SearchClearSaveRow
                        onClickSearch={handleSearch}
                        onClickClear={() => dispatch({ type: 'clear' })}
                        onClickSave={handleSaveUpdate}
                    />
                    {(rows.length > 0) ? (
                        <GridInputRow>
                            <Grid item xs={12}>
                                <DefaultDatagrid
                                    columns={columns(t)}
                                    allowPaging={true}
                                    dataSource={rows}
                                    cellSelected={(args, grid) =>
                                        handleCellClick(args.data)
                                    } />
                            </Grid>
                        </GridInputRow>
                    ) : null}
                </GridItemContainer>
            } />
    );
}